import { BareActionContext } from 'vuex-typex'
import { ConvoState } from '../state'
import { RootState } from '../..'
import convoUtils from './convo-utils'
import fetchStatements from './fetch-statements'
import { IStatement } from '@/model/statement';
import convoStore from '@/store/convo/convo-store';
import statementStore from '@/store/statement/statement-store';

export default async function removeConvoStatement(context: BareActionContext<ConvoState, RootState>, statement: IStatement)
{
  console.log('removeConvoStatement');
  convoUtils.convoService.removeStatement(convoStore.state.convo, statement).then((result: any) => {
    statementStore.dispatchSetStatementQuery()
    fetchStatements(context, convoStore.state.convo)
  })

  return
}
